import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import "./PrintForm.css";
import { useLocation, useNavigate } from "react-router-dom";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";


function PrintForm() {

    const [userDetails, setUserDetails] = useState(null);

    const navigate = useNavigate();
    const loc = useLocation();
    setInterval(() => {
        if (!Cookies.get("userInfo")) {
            logout();
        }
    }, 1000);
    useEffect(() => {
        if (Cookies.get("username") != "VerifyOfficer") {
            alert("unauthorized to this page")
            logout();
        }
        async function fetchData() {
            var reqData = {
                mobile: loc.state.mobile
            }
            try {
                const resData = await axios.post("/api/get-scholar-print-details", reqData);
                if (resData.status === 200) {
                    setUserDetails(resData.data.data);
                }
            } catch (e) {
                if (e.code === "ERR_BAD_REQUEST") {
                    console.log(e);
                    // logout();
                }
            }
        }
        removeNavbar();
        fetchData();
    }, [])
    function removeNavbar() {
        document.getElementsByClassName("navbar")[0].style.display = "none";
      }
    return (
        <>
            {(userDetails === null) ? (
                <center>
                    <RotateLeftIcon
                        sx={{
                            fontSize: "3rem",
                            margin: "0 auto",
                            color: "rgba(0,0,0,0.6)",
                            animation: "spin 1s linear infinite",
                            "@keyframes spin": {
                                "0%": {
                                    transform: "rotate(360deg)",
                                },
                                "100%": {
                                    transform: "rotate(0deg)",
                                },
                            },
                        }}
                    />{" "}
                    Loading Details
                </center>
            ) : (
                <>
                <center>
                   <table className="payment-table" >
                        <tr >
                            <td className="tde"><center>
                                <p><b><u>Fee Details</u></b>
                            <br/><br />
                                <b>UPI reference ID :</b>{userDetails.transaction_id}
                                <br /><br />
                                <b>Online/phonepay/G.Pay Amount :</b>{userDetails.transaction_amount}
                                 <br /><br />
                                <b>Date Of Payment :</b>{userDetails.date_of_payment}
                                <br /> 
                                </p></center>
                            </td>
                            <td className="tde">
                                <center>
                                <img className="photo" src={axios.defaults.baseURL + "api/media/" +userDetails.photo} />
                                </center>
                            </td>
                        </tr>
                    </table >   
                    <br/>
                    <table className="sub-tab">
                        <tr>
                            <th className="the"> Application ID</th>
                            <td className="tde">{userDetails.id}
                            </td>
                        </tr>
                        <tr>
                            <th className="the">Name Of The Candidate</th>
                            <td className="tde">{userDetails.name}
                            </td>
                        </tr>
                        <tr>
                            <th className="the">Father Name</th>
                            <td className="tde">{userDetails.father_name}</td>
                        </tr>
                        <tr>
                            <th className="the">Social Status</th>
                            <td className="tde">{userDetails.social_category}</td>
                        </tr>
                        <tr>
                            <th className="the">Date Of Birth</th>
                            <td className="tde">{userDetails.date_of_birth}</td>
                        </tr>
                        <tr>
                            <th className="the">Mobile No</th>
                            <td className="tde">{userDetails.mobile}
                            </td>
                        </tr>
                        <tr>
                            <th className="the">Email id </th>
                            <td className="tde">{userDetails.email}</td>
                        </tr>
                        <tr>
                            <th className="the">Permanant Address</th>
                            <td className="tde">{userDetails.permanent_address}</td>
                        </tr>
                        <tr>
                            <th className="the">Subject/Branch</th>
                            <td className="tde">{userDetails.supervisor_department}</td>
                        </tr>
                        <tr>
                            <th className="the">College/Institution</th>
                            <td className="tde">{userDetails.supervisor_address}</td>
                        </tr>
                        <tr>
                            <th className="the">Faculty </th>
                            <td className="tde">{userDetails.faculty}</td>
                        </tr>
                        <tr>
                            <th className="the">M.A/M.Sc. M.Com. /P.G or its equal examination has passed</th>
                            <td className="tde">{userDetails.degree}</td>
                        </tr>
                        <tr>
                            <th className="the" style={{paddingLeft:"100px"}} >a.Name of the University</th>
                            <td className="tde">{userDetails.name_of_university}</td>
                        </tr>
                        <tr>
                            <th className="the" style={{paddingLeft:"100px"}} >b.Month/ Year of passing</th>
                            <td className="tde">{userDetails.month_year_passing}</td>
                        </tr>
                        <tr>
                            <th className="the">Name of the Supervisor</th>
                            <td className="tde">{userDetails.name_of_supervisor}</td>
                        </tr>
                        <tr>
                            <th className="the">Title of the Thesis</th>
                            <td className="tde">{userDetails.title_of_thesis}</td>
                        </tr>
                        <tr>
                            <th className="the">Academic year of Admission of Ph.D. Course</th>
                            <td className="tde">{userDetails.admission_year_of_phd}</td>
                        </tr>
                        <tr>
                            <th className="the"> Pre-Ph.D Passing Month and Year</th>
                            <td className="tde">{userDetails.pre_phd_passing_month_year}</td>
                        </tr>

                        <tr>
                            <th className="the">Full time /Part-time</th>
                            <td className="tde">
                                {userDetails.time}
                            </td>
                        </tr>
                        <tr>
                            <th className="the">Are you submitting thesis within your prescribed time? </th>
                            <td className="tde">
                                {userDetails.thesis_on_time}
                            </td>
                        </tr>
                    </table>
                </center>
                <br/>
                    <p className="pp"><b>Date Of Application : </b>{userDetails.date_of_application}
                    
                        <b className="bb"><img class="image" src={axios.defaults.baseURL + "api/media/" + userDetails.signature_of_applicant}/>
                            <br/>
                        Signature 
                    </b>
                    </p>
                </>
            )}
        </>
    )
}

export default PrintForm;

function logout() {
    window.localStorage.clear();
    Cookies.remove("userInfo");
    Cookies.remove("username");
    window.location.href = "/pvtOfficer-login";
}